import React, { useState, useCallback } from 'react';
import { Tooltip, IconButton, makeStyles } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import buttonStyles from './styles';

const useStyles = makeStyles(() => ({
  helpContainer: {
    display: 'inline',
    position: 'relative',
  },
  helpContent: {
    position: 'absolute',
    width: '300px',
    height: '400px',
    backgroundColor: '#f5f6fa',
    opacity: '0.9',
    borderRadius: 24,
    border: '4px dashed #ff5a0f',
    zIndex: 9,
    padding: '20px',
  },
}));

type Props = {};

const LabelHelpButton = React.memo((props: Props) => {
  const buttonClasses = buttonStyles();
  const classes = useStyles();
  const [showHelp, setShowHelp] = useState<boolean>(false);

  const toggleHelp = useCallback(() => {
    setShowHelp((value) => !value);
  }, []);

  return (
    <React.Fragment>
      <Tooltip title={'Help me!'} arrow>
        <IconButton
          onClick={toggleHelp}
          className={showHelp ? buttonClasses.toggleIconActive : buttonClasses.toggleIcon}
          size="small"
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      {showHelp && (
        <div className={classes.helpContainer}>
          <div className={classes.helpContent}>
            <b>Marker</b>
            <br />
            <br />
            <i>
              <b>Green Circle</b>
            </i>
            <br />
            - We're verifying the track positions, data is saved as correct if you don't intervene.
            <br />
            <i>
              <b>Blue Circle</b>
            </i>
            <br />
            - We're viewing already saved positions.
            <br />
            <i>
              <b>Yellow Cross</b>
            </i>
            <br />
            - No location found, playing video until cross becomes red.
            <br />
            <i>
              <b>Red Cross</b>
            </i>
            <br />- Please label a new position.
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

export default LabelHelpButton;
